module.exports = __webpack_public_path__ + "img/chart.731e0b6c.png";